export default __webpack_public_path__ + "static/realWorldImg2-2eb7d7d339b19133457518876ab28be1.png";